import type { VerticalConfig } from '@garnet/config';
import { AUTOMOTIVE, MEDICAL } from '@garnet/config';

/**
 * The console serves both launch verticals from ONE screen layer (PRD §38): a vertical is
 * a CONFIG plus a dataset, never a code fork. `Vertical` selects which dataset the
 * FixtureApi seeds from; the matching `VerticalConfig` from @garnet/config drives the
 * identity labels and copy so the vertical switcher proves §38.
 */
export type Vertical = 'medical' | 'automotive';

/** The two verticals the console ships, with their @garnet/config CONFIG. */
export const VERTICAL_CONFIG: Record<Vertical, VerticalConfig> = {
  medical: MEDICAL,
  automotive: AUTOMOTIVE,
};

export const VERTICALS: readonly Vertical[] = ['medical', 'automotive'] as const;
